import styled from 'styled-components';
import { FileUploadStatus } from './constants';

export const FileUploadAreaWrapper = styled.div<{ status: FileUploadStatus }>(
  ({ theme, status }) => `
  background-color: ${
    status === FileUploadStatus.NOT_INITIATED
      ? 'transparent'
      : status === FileUploadStatus.FAILURE
      ? theme.colors.interactive.background.negative.disabled
      : theme.colors.surface.background.gray.intense
  };
  width: 500px;
  min-height: 56px;
  max-height: fit-content;
  border-color: ${
    status === FileUploadStatus.NOT_INITIATED
      ? theme.colors.interactive.border.gray.default
      : status === FileUploadStatus.FAILURE
      ? theme.colors.interactive.background.negative.faded
      : theme.colors.interactive.border.gray.faded
  };
  border-width: ${theme.border.width.thin}px;
  border-style: ${status === FileUploadStatus.NOT_INITIATED ? 'dashed' : 'solid'};
  border-radius: ${theme.border.radius.medium}px;
  cursor: ${status === FileUploadStatus.NOT_INITIATED ? 'pointer' : 'default'};

  :hover {
    background-color: ${
      status === FileUploadStatus.NOT_INITIATED
        ? theme.colors.surface.background.gray.moderate
        : 'none'
    };
  }

  #file-upload-icon {
    display: flex;
    align-items: flex-start;
    padding: ${theme.spacing[3]}px;
    gap: ${theme.spacing[3]}px;
    width: ${theme.spacing[9]}px;
    height: ${theme.spacing[9]}px;
  }
  .invisible {
    visibility: none;
    opacity: 0;
    position: absolute;
    width: 0.1px;
    height: 0.1px;
  }
`,
);
